<!-- Translated: yes -->
<template>
  <div :class="'background-blue ' + 'step-' + stage">
    <div :style="!SITE_CONFIG.modules_open.skiletting.open ? 'visibility: hidden;' : ''">
      <Timeline :steps="timelineSteps" theme="light"></Timeline>
      <OnSiteFooter v-if="$store.state.isOnSite" />
    </div>

    <Back :clicked="goBack" />
    <!-- <LanguageSwitcher type="dropdown" v-if="!$store.state.isOnSite" :show-title="false" @pickedlanguage="reload" /> -->

    <div v-if="!SITE_CONFIG.modules_open.skiletting.open" class="rental-closed">
      <p>{{ SITE_CONFIG.modules_open.skiletting.closed_message }}</p>
    </div>

    <div v-if="SITE_CONFIG.modules_open.skiletting.open">

    <div class="remove-user" @click="remove(index)" v-if="parseInt($route.params.person)">{{ $t('skirental.remove-title', {skier: ''}) }} <button class="white small"><icon name="trash" :scale="1.4" /></button></div>
<!--
Antal kvar: {{filtered.length}}
Steg: {{stage}}
-->

    <div :class="'content center a-step step-' + 10" v-if="stage >= 10">

      <h1 v-if="$route.params.person === '0'">{{ $t('skirental.book-first-skier') }}</h1>
      <h1 v-if="$route.params.person !== '0'">{{ $t('skirental.book-skier-x', {number: parseInt($route.params.person) + 1}) }}</h1>

      <div :class="'box checkboxes'" style="margin-bottom:1.5rem;">
        <Checkbox special-class="rental-user" label="Ny" label-position="right" :value="false" :valuebinder.sync="tabSaved"></Checkbox>
        <Checkbox special-class="rental-user" label="Sparad" label-position="right" :value="true" :valuebinder.sync="tabSaved"></Checkbox>
      </div>

      <div class="flex" v-if="tabSaved">
        <div class="control" v-if="!loggedIn">
          <Login @login="onLogin" />
        </div>

        <div v-if="loggedIn && !skiers.length && !loadingSkiers">
          <div class="control" style="margin-top:1rem;">
            <Note title="Inga åkare" color="white">
              <p>Vi hittade inga sparade åkare.</p>
            </Note>
          </div>
        </div>

        <div v-if="loggedIn && loadingSkiers">
          <div class="control">
            <Loading :show="loadingSkiers" :static="true" />
          </div>
        </div>

        <div v-if="loggedIn && skiers.length">
          <div class="control">
            <div class="label no-left-margin">Välj bland dina åkare</div>
            <Dropdown
              :options="skiersAsSelect"
              :valuebinder.sync="skierId"
              :validated="skierId"
              label="Välj åkare"
              @changed="setSkier"
              />
          </div>
        </div>
      </div>

      <div class="flex" v-if="!tabSaved">
        <div class="control">
          <div class="label no-left-margin">{{ $t('general.name') }}</div>
          <div :class="'flex flexer ' + (validatedName ? 'selected' : '')">
            <input tabindex="0" ref="nameInput" @focus="inValidateName" @keyup.enter="validateName($event); validateStep10($event);" type="text" class="input" v-model="name" @blur="validateName($event); validateStep10($event);" />
            <span class="suffix" @click="focusName">
              <icon v-if="!validatedName" name="empty" :scale="1.5"></icon>
              <icon v-if="validatedName" name="circle-green-minus" :scale="1.5"></icon>
            </span>
          </div>
        </div>
      </div>

    </div>

    <hr v-if="stage >= 10">

    <div :class="'content center a-step step-' + 13 + (stage < 13 ? ' disabled' : '')" v-if="stage >= 10">

      <div class="inline-block min-width white-text" v-if="parseInt($route.params.person) > 0">
        <p><b>{{ $t('skirental.rental-period-title') }}: <span v-html="formatDate(pickedStartDate)"></span></b></p>
        <p>{{ $t('skirental.rental-period-text') }}</p>
      </div>

      <div style="margin-bottom: 25px;" v-if="delivery">
        <div class="inline-block min-width white-text" style="text-align:left;">
          <b><icon name="info" :scale="1.4" />{{ $t('skirental.delivery.title') }}</b>
          <ul>
            <li v-for="(message, index) in deliveryMessages" :key="index" v-html="message">{{message}}</li>
            <li v-if="possibleWithStorage"><strong>OBS! Nattförvaring.</strong> Istället för utkörning har ditt boende ett förvaringsbås i skiduthyrningen fem meter från åkbar snö. I ditt skidnära bås kan du förvara dina skor under dagen så att du kan gå i dina bekväma skor till och från ditt boende.</li>
          </ul>
        </div>
      </div>

      <div class="inline-block min-width" v-if="parseInt($route.params.person) === 0">
        <label class="label no-left-margin" v-if="stage <= 13">{{ $t('general.pick-days') }}</label>

        <Dropdown
          prefixicon="calendar"
          prefixicon-validated="calendar-white"
          ref="dateDropdown"
          tabindex="0"
          :options="[]"
          :validated="selectedDays"
          :label="'' + formatDate(pickedStartDate) + ''"
          @clicked="datepickerRangeModal"
          :bold-label="false"
          @clicked-suffix="dateClear">
        </Dropdown>
      </div>

    </div>

    <hr v-if="stage >= 10">

    <div class="center">

      <div :class="'content inline-block a-step step-' + 16 + (stage > 10 ? ' inline-block' : '') + ' ' + (stage < 16 ? ' disabled' : '')" v-if="stage >= 10">

        <div class="label" v-if="stage <= 16">{{ $t('general.pick-age') }}</div>

        <div class="center">
          <div
            v-for="option in options"
            @click="setAge(option.value)"
            v-if="(!selectedAge || selectedAge === option.value)"
            :class="{
              button: true,
              underlined: true,
              'small-text': true,
              checked: (selectedAge === option.value),
              'has-description': option.subtitle
              }"
            >
            {{option.title}}
            <span v-if="option.subtitle /*&& stage === 16*/">{{option.subtitle}}</span>
          </div>

        </div>

      </div>

      <hr v-if="stage == 20">

      <div :class="'content a-step step-' + 20 + (stage > 16 ? ' inline-block' : '')" v-if="stage >= 20">

        <div class="label" v-if="stage <= 20">{{ $t('skirental.what-to-rent') }}</div>
        <div class="center">
          <div
            v-for="(category) in categories"
            @click="setCategory1(category.slug, category)"
            v-if="((!selectedCategory || selectedCategory === category.slug) && (!category.parent) && category.name)"
            :class="{
              button: true,
              underlined: true,
              'small-text': true,
              checked: (selectedCategory === category.slug)
            }"
            v-html="(selectedCategory === 'other') ? ((
              subCategories && subCategories[selectedSubCategory] && subCategories[selectedSubCategory].name
              ) ? subCategories[selectedSubCategory].name : $t('skirental.other-equipment')) : category.name"
            >
          </div>

        </div>

      </div>

      <hr v-if="stage == 30">

      <div :class="'content a-step step-' + 30 + (stage > 16 ? ' inline-block' : '')" v-if="stage >= 30">

        <!-- Ski cart skicart ski-cart -->
        <!-- <div class="inline-block min-width white-text" v-if="SITE_CONFIG.site === 'branas' && stage == 30 && selectedSubCategory === 'disability'">
          <p v-html="$t('skirental.contact-sales-for-disability', {phone: '<a href=\'tel:054-132600\'>054-132600</a>'})"></p>
        </div> -->

        <div class="label max-mobile label-products">{{ $t('skirental.what-to-rent') }}</div>

        <div class="center">
          <div
            v-for="(product, key) in products"
            @click="setType(key)"
            v-if="(!selectedType || selectedType === key) && showProduct(key)"
            :class="{
              button: true,
              'small-text': true,
              white: true,
              checked: (selectedType === key),
              'has-description' : (product.description && stage === 30)
              }"
              >
            {{product.title}}
            <span v-if="stage == 30">{{product.description}}</span>
          </div>
        </div>

      </div>

    </div>

    <hr v-if="stage >= 40">

    <div :class="'content a-step step-' + 40" v-if="stage >= 40">
    <h1 class="level-phone">{{ $t('skirental.pick-level') }}</h1>
      <div class="flex">

        <div @click="setPackage('beginner')" :class="'box ' + (searchPackage === 'beginner' ? 'active' : '')">
          <h3>{{ $t('general.levels.beginner') }}</h3>
          <ul>
            <li>{{ $t('skirental.level-bullets.1') }}</li>
            <li>{{ $t('skirental.level-bullets.2') }}</li>
          </ul>
          <button class="block ski-bt">{{ $t('general.pick') }}</button>
        </div>

        <div @click="setPackage('intermediate')" :class="'box ' + (selectedAge !== 'children' ? 'larger' : '') + ' ' + (searchPackage === 'intermediate' ? 'active' : '')">
          <div class="banner" v-if="selectedAge !== 'children'">{{ $t('general.popular-choice') }}</div>
          <h3>{{ $t('general.levels.average') }}</h3>
          <ul>
            <li>{{ $t('skirental.level-bullets.3') }}</li>
            <li>{{ $t('skirental.level-bullets.4') }}</li>
          </ul>
          <button class="block ski-bt">{{ $t('general.pick') }}</button>
        </div>

        <div @click="setPackage('advanced')" :class="'box ' + (searchPackage === 'advanced' ? 'active' : '')" v-if="selectedAge !== 'children'">
          <h3>{{ $t('general.levels.advanced') }}</h3>
          <ul>
            <li>{{ $t('skirental.level-bullets.5') }}</li>
            <li>{{ $t('skirental.level-bullets.6') }}</li>
          </ul>
          <button class="block ski-bt">{{ $t('general.pick') }}</button>
        </div>

      </div>

    </div>

    <div class="next">
      <button class="block border" @click="goForward" :disabled="!currentStepValid" v-if="currentStepValid || (stage === 10 || stage === 13)">{{ $t('general.go-on') }} <icon name="arrow-white" :scale="1.2" /></button>
    </div>

  </div>
  </div>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex';
import API from '@/classes/API';
import Dropdown from '@/components/components/Dropdown';
import Datepicker from '@/components/components/Datepicker';
import Timeline from '@/components/components/Timeline';
import Checkbox from '@/components/components/Checkbox';
import Login from '@/components/payments/Login';
import Note from '@/components/components/Note';
import _ from 'lodash';

import rentalTimelineSteps from '@/mixins/rentalTimelineSteps';

import OnSiteFooter from '@/components/components/OnSiteFooter';

import Back from '@/components/components/Back';
import LanguageSwitcher from '@/components/components/LanguageSwitcher';

import {
  validStartDate,
} from '@/dates';

import {
  dayCountExcludeClosed,
  hasClosedDaysInRange,
  endDateIncludeClosed,
} from '@/lib';

import moment from 'moment';

export default {
  components: {
    Dropdown,
    Datepicker,
    Timeline,
    OnSiteFooter,
    Back,
    LanguageSwitcher,
    Checkbox,
    Login,
    Note,
  },
  mixins: [rentalTimelineSteps],
  data() {
    return {
      name: '',
      selectedAge: '',
      pickedStartDate: null,
      selectedDays: 0,
      stage: 10,
      selectedCategory: '',
      selectedSubCategory: '',
      selectedType: '',
      searchPackage: '',
      validatedName: false,
      options: [{
        value: 'children',
        title: 'Barn',
        subtitle: '(0-6 år)',
      }, {
        value: 'youths',
        title: 'Ungdom',
        subtitle: '(7-17 år)',
      }, {
        value: 'adults',
        title: 'Vuxen',
        subtitle: '(18-64 år)',
      }, {
        value: 'seniors',
        title: 'Senior',
        subtitle: '65+ år',
      }],
      categories_all: [],
      categories_main: [],
      categories_other: [],
      delivery: false,
      allProducts: [],
      priceType: 'day',
      showedWarning: false,
      possibleWithStorage: false,
      deliveryMessages: [],
      tabSaved: false,
      loadingSkiers: false,
      skiers: [],
      skierId: '',
      skier: {},
    };
  },
  watch: {
    tabSaved(value) {
      if (!value) {
        this.skierId = '';
        this.skier = {};
      }
    },
  },
  async mounted() {
    const years = this.$i18n.t('general.years'); // eslint-disable-line
    this.options[0].subtitle = `${this.SITE_CONFIG.skipass.ages.children} ${years}`;
    this.options[1].subtitle = `${this.SITE_CONFIG.skipass.ages.youths} ${years}`;
    this.options[2].subtitle = `${this.SITE_CONFIG.skipass.ages.adults} ${years}`;
    this.options[3].subtitle = `${this.SITE_CONFIG.skipass.ages.seniors} ${years}`;

    if (!this.SITE_CONFIG.skipass.ages.seniors) {
      this.options.splice(3, 1);
    }

    this.options[0].title = this.$i18n.t('general.ages.child');
    this.options[1].title = this.$i18n.t('general.ages.youth');
    this.options[2].title = this.$i18n.t('general.ages.adult');

    let person = this.$store.state.cart.rentals[this.$route.params.person];
    if (!person) {
      person = {};
    }

    this.name = person.name;
    this.priceType = person.priceType;
    this.loading = true;
    this.validateStep10();
    await this.mountedDateLogic();

    this.setAge(person.age);
    this.setCategory1(person.category);
    this.pickedCategory(person.subCategory);
    this.setType(person.type);
    this.setPackage(person.searchPackage);
    this.loading = false;

    this.delivery = person.delivery;

    if (this.$store.state.cart.rentals[0].deliveryTo
      && this.$store.state.cart.rentals[0].deliveryTo.pool_lid) {
      const pool = this.$store.state.cart.rentals[0].deliveryTo.pool_lid;
      const unit = this.$store.state.cart.rentals[0].deliveryTo.unit_lid;
      const { success } = await API.get(`equipment-storage-available/${pool}/${unit}`);
      this.possibleWithStorage = success;
    }

    this.deliveryMessages = [];
    this.SITE_CONFIG.delivery_messages.forEach((message) => {
      if (message[2]) {
        if (moment(message[2]).isAfter(moment().toString())) {
          this.deliveryMessages.push(message[1]);
        }
      } else {
        this.deliveryMessages.push(message[1]);
      }
    });

    await this.reload();
    await this.fetchSkiers();
  },
  computed: {
    ...mapGetters([
      'loggedIn',
    ]),
    filtered() {
      return this.allProducts.filter((product) => {
        const selectedCategory = this.selectedSubCategory || this.selectedCategory;
        return (
          (!this.selectedAge || product.age === this.selectedAge || product.age === 'all')
          &&
          (!selectedCategory || product.categories.filter(
            category => selectedCategory === category.slug,
          ).length)
          &&
          (!this.selectedType || product.type === this.selectedType)
        );
      });
    },
    categories() {
      const cats = {};

      this.allProducts.forEach((product) => {
        product.categories.forEach((category) => {
          if (this.SITE_CONFIG.site === 'tolvmannabacken' || this.SITE_CONFIG.site === 'storstenshojden') {
            if (product.addon && category.slug !== 'protection') {
              return;
            }
          }

          let slug = category.slug;

          cats[category.slug] = Object.assign({}, category);
          if (category.parent) {
            cats[category.parent.slug] = Object.assign({}, category.parent);
            slug = category.parent.slug;
          }

          cats[slug].name = this.$i18n.t(`general.category-${slug}`);
        });
      });

      console.log(cats);

      const orderedCats = _.orderBy(cats, ['id'], ['asc']);
      return orderedCats;
    },
    subCategories() {
      const cats = {};

      this.allProducts.forEach((product) => {
        product.categories.forEach((category) => {
          if (category.parent) {
            cats[category.slug] = Object.assign({}, category);
          }
        });
      });

      // Hardcoded
      if (this.selectedAge === 'children' || this.selectedAge === 'youths') {
        delete cats.telemark;
      }
      if (this.selectedAge === 'children') {
        delete cats.snowblades;
      }

      return cats;
    },
    validStartDate() {
      return validStartDate({
        validStartDates: this.validStartDates,
      });
    },
    products() {
      let description = this.$i18n.t('skirental.category-descriptions.package');

      if (this.selectedCategory === 'alpine') {
        description = this.$i18n.t('skirental.category-descriptions.alpine');
      } else if (this.selectedCategory === 'snowboard') {
        description = this.$i18n.t('skirental.category-descriptions.snowboard');
      } else if (this.selectedSubCategory === 'cross_country') {
        description = this.$i18n.t('skirental.category-descriptions.cross_country');
      } else if (this.selectedSubCategory === 'telemark') {
        description = this.$i18n.t('skirental.category-descriptions.telemark');
      } else if (this.selectedSubCategory === 'snowblades') {
        description = this.$i18n.t('skirental.category-descriptions.snowblades');
      } else if (this.selectedSubCategory === 'clothes') {
        description = this.$i18n.t('skirental.category-descriptions.clothes');
      }

      const packages = this.filtered.filter(a => a.package).length;
      const single = this.filtered.filter(a => a.single).length;

      const r = {};

      if (packages) {
        r.package = {
          title: this.$i18n.t('skirental.category-types.package'),
          description,
        };
      }
      if (single) {
        r.single = {
          title: this.$i18n.t('skirental.category-types.single'),
          description: this.$i18n.t('skirental.category-types.single-text'),
        };
      }

      return r;
    },
    currentStepValid() {
      if (this.stage === 10 || this.stage === 13) {
        return this.name && this.selectedDays;
      } else if (this.stage === 16) {
        return this.selectedAge;
      } else if (this.stage === 20) {
        return this.selectedCategory;
      } else if (this.stage === 30) {
        return this.selectedType;
      } else if (this.stage === 40) {
        return this.searchPackage;
      }
      return false;
    },
    skiersAsSelect() {
      return this.skiers.map(s => ({
        value: s.guid,
        title: `${s.first_name || ''} ${s.last_name || ''}`,
      }));
    },
  },
  methods: {
    ...mapMutations([
      'openModal',
      'updateRentalPerson',
      'updateRentalPersonMeasurements',
      'closeModal',
    ]),
    async reload() {
      let date = '';
      if (this.pickedStartDate) {
        date = moment(this.pickedStartDate).format('YYYY-MM-DD');
      }
      const days = this.selectedDays;
      this.setCategoriesFromSearch(date, days);
    },
    setCategoriesFromSearch(options = {}) {
      const age = options.age ? `age=${options.age}` : false;
      const category = options.category ? `category=${options.category}` : false;
      const date = options.date ? `date=${options.date}` : false;
      const days = options.days ? `days=${options.days}` : false;
      // Building the search params for each parameter passed
      let requestUrl = '';
      requestUrl = [age, category, date, days].filter(Boolean).join('&');

      API.get(`/skiletting/search?${requestUrl}`)
      .then((response) => {
        this.allProducts = response.data;
        this.categories_all = response.meta.categories_all;
        this.categories_main = response.meta.categories_main;
        this.categories_other = response.meta.categories_other;
      });
    },
    goBack() {
      if (window.screenSize() > window.screenMobile) {
        if (this.$route.params.person.toString() === '0') {
          // if (confirm('Vill du verkligen avbryta din bokning?')) { // eslint-disable-line
          // this.$store.state.cart.rentals = [];
          this.$router.push({ name: 'ski rental' });
          return;
          // }
        }
        // } else {
        this.$router.push({ name: 'ski rental overview' });
        // }
      }

      if (this.stage === 10 || this.stage === 13) {
        this.$router.push({ name: 'ski rental overview' });
      } else if (this.stage === 16) {
        this.stage = 13;
      } else if (this.stage === 20) {
        this.stage = 16;
      } else if (this.stage === 30) {
        this.stage = 20;
      } else if (this.stage === 40) {
        this.stage = 30;
      }
    },
    goForward() {
      if (this.stage === 10 || this.stage === 13) {
        this.stage = 16;
      } else if (this.stage === 16) {
        this.stage = 20;
      } else if (this.stage === 20) {
        this.stage = 30;
      } else if (this.stage === 30) {
        this.stage = 40;
      } else if (this.stage === 40) {
        this.next();
      }
    },
    showProduct(key) {
      let show = false;
      this.allProducts.forEach((product) => {
        if (product[key]) {
          show = true;
        }
      });
      return show;
    },
    validateName(e) {
      if (this.name.length) {
        this.validatedName = true;
      } else {
        this.validatedName = false;
      }
      e.stopPropagation();
    },
    inValidateName() {
      this.validatedName = false;
    },
    focusName() {
      this.$refs.nameInput.focus();
    },
    selectDates(start, end, type) {
      if (start) {
        this.pickedStartDate = start;
      } else {
        return;
      }
      let newEnd = end;
      if (!newEnd) {
        newEnd = start;
      }
      this.selectedDays = dayCountExcludeClosed(start, newEnd);
      this.priceType = type;
      this.stage = Math.max(this.stage, 16);

      this.validateDate();

      this.$store.state.cart.rentals.forEach((person, index) => {
        this.$store.state.cart.rentals[index].days = this.selectedDays;
        this.$store.state.cart.rentals[index].startDate = this.pickedStartDate;
      });

      // IF a skier is selected, we know that age is also already selected
      if (this.skierId && this.skier.age_category && this.selectedAge) {
        this.refreshProductsFromAge(this.selectedAge);
        this.update();
        this.stage = Math.max(this.stage, 20);
      }
    },
    openWarningModal() {
      const $this = this;
      this.openModal(['GeneralModal', {
        title: (this.stage < 13 ? this.$i18n.t('general.pick-skier-name') : this.$i18n.t('general.pick-date')),
        content: (this.stage < 13 ? this.$i18n.t('skirental.rules.pick-skiers-name') : this.$i18n.t('skirental.rules.pick-date')),
        buttons: [
          {
            title: this.$i18n.t('general.okay'),
            class: 'small',
            click: () => {
              $this.closeModal();
            },
          },
        ],
      }]);
    },
    datepickerRangeModal() {
      if (this.stage >= 13) {
        const endDate = endDateIncludeClosed(this.pickedStartDate, this.selectedDays);
        this.openModal(['DatepickerRangeModal', {
          validDates: this.validStartDates,
          pickedStartDate: this.pickedStartDate,
          pickedEndDate: endDate,
          onClose: this.selectDates,
          onPickStart: this.setEndDates,
          onPickStartInfo: this.setDateInfo,
          night: this.SITE_CONFIG.season.winter.night,
          open: this.SITE_CONFIG.modules_open.skiletting.open,
          closed_message: this.SITE_CONFIG.modules_open.skiletting.closed_message,
          type: 'skiletting',
          disableSingle: this.delivery,
        }]);
      } else {
        this.openWarningModal();
      }
    },
    setEndDates(startDate) {
      if (!startDate) {
        return new Promise((resolve) => {
          resolve(this.SITE_CONFIG.rental.days_max);
        });
      }
      const d = moment(startDate).format('YYYY-MM-DD');
      return API.get(`/skiletting/get-end-day-limit/${d}`);
    },
    setDateInfo(startDate) {
      const d = moment(startDate).format('YYYY-MM-DD');

      if (!startDate) {
        return new Promise((resolve) => {
          resolve('');
        });
      }

      if (this.SITE_CONFIG.site === 'kungsberget') {
        API.get(`config/is-skipass-date-allowed?date=${d}`).then((payload) => {
          if (!payload.data && !this.showedWarning) {
            this.showedWarning = true;
            const $this = this;
            this.openModal(['GeneralModal', {
              title: '',
              content: `<p>Vi är fullbokade ${d}, av den anledningen kan du inte boka liftkort eller köpa på plats.</p><p>Anläggningens boendegäster och säsongskortsgäster har alltid platser reserverade.</p><p><b>Vill du fortsätta boka utrustning för ${d}?</b></p>`,
              buttons: [{
                title: 'Fortsätt bokning',
                class: 'small',
                click: () => {
                  $this.closeModal();
                },
              }, {
                title: 'Avbryt bokning',
                class: 'small white border',
                click: () => {
                  window.history.back();
                },
              }],
            }]);
          }
        });
      }
      if (this.SITE_CONFIG.site !== 'ulricehamn') {
        return new Promise((resolve) => {
          resolve('');
        });
      }

      return API.get(`/skiletting/first-time/${d}`);
    },
    dateClear() {
      this.pickedStartDate = null;
      this.selectedDays = null;
      this.stage = 13;
    },
    formatDate() {
      const selectedDays = Math.round(this.selectedDays || 0);
      const start = this.pickedStartDate ? moment(this.pickedStartDate).format('D/M') : '';
      const end = this.pickedStartDate ? moment(this.pickedStartDate).add(selectedDays - 1, 'days').format('D/M') : '';
      // const night = this.$i18n.t('general.night');
      const hours = this.$i18n.t('skirental.day-options.hours', { hours: this.SITE_CONFIG.rental.night_hours });
      const day = this.$i18n.t('general.day');
      const days = this.$i18n.t('general.days');
      if (selectedDays) {
        if (selectedDays === 1) {
          if (this.priceType === 'night') {
            // if (this.SITE_CONFIG.site === 'vallasen') {
            //   return `${selectedDays} ${night} <span class="thin">(${start})</span>`;
            // }
            return `${hours} <span class="thin">(${start})</span>`;
          }
          return `${selectedDays} ${day} <span class="thin">(${start})</span>`;
        }

        if (hasClosedDaysInRange(this.pickedStartDate, selectedDays)) {
          return `${selectedDays} ${days}`;
        }
        return `${selectedDays} ${days} <span class="thin">(${start} - ${end})</span>`;
        // return ;
      }
      return this.$i18n.t('general.pick-ski-date');
    },
    pickDate(payload) {
      // return payload;
      this.$refs.dateDropdown.close();
      this.pickedStartDate = new Date(payload);
    },
    async mountedDateLogic() {
      this.validStartDates = [];
      let loopStart = moment(this.SITE_CONFIG.season.winter.start).subtract(1, 'day').toDate();
      let end = moment(this.SITE_CONFIG.season.winter.end).toDate();
      let next = null;

      if (this.$store.state.cart.addToOrder && this.$store.state.cart.addToOrder.dateStart) {
        if (moment(this.$store.state.cart.addToOrder.dateStart).subtract(1, 'day').toDate() >= loopStart) {
          loopStart = moment(this.$store.state.cart.addToOrder.dateStart).subtract(1, 'day').toDate();
        }
        if (moment(this.$store.state.cart.addToOrder.dateEnd).toDate() <= end) {
          end = moment(this.$store.state.cart.addToOrder.dateEnd).toDate();
        }
      }

      let date = null;
      let days = null;

      let currentPerson = this.$store.state.cart.rentals[this.$route.params.person];
      if (!currentPerson) {
        currentPerson = {};
      }

      const allAccomodations = JSON.parse(JSON.stringify(this.$store.state.cart.accomodations));
      const allConfirmed = allAccomodations.filter(accomodation => accomodation.confirmed);

      if (this.$store.state.cart.addToOrder && this.$store.state.cart.addToOrder.dateStart) {
        date = this.$store.state.cart.addToOrder.dateStart;
        days = Math.round(moment(this.$store.state.cart.addToOrder.dateEnd).diff(
          this.$store.state.cart.addToOrder.dateStart) / 60 / 60 / 24 / 1000) + 1;
      } else if (currentPerson.delivery) {
        if (allConfirmed.length) {
          if (allConfirmed[0].arrival) {
            date = allConfirmed[0].arrival;
            days = Math.round(moment(allConfirmed[0].departure).diff(
              allConfirmed[0].arrival) / 60 / 60 / 24 / 1000) + 1;
          } else {
            date = allConfirmed[0].period.date_arrival;
            days = Math.round(moment(allConfirmed[0].period.date_departure).diff(
              allConfirmed[0].period.date_arrival) / 60 / 60 / 24 / 1000) + 1;
          }
        }
      }

      if (date) {
        this.$store.state.cart.rentalDateRestriction = {
          date,
          days,
        };
      } else {
        this.$store.state.cart.rentalDateRestriction = {};
      }

      if (this.$store.state.cart.rentalDateRestriction.date
        && this.$store.state.cart.rentalDateRestriction.days) {
        loopStart = moment(this.$store.state.cart.rentalDateRestriction.date).subtract(1, 'day').toDate();
        end = moment(loopStart).add(this.$store.state.cart.rentalDateRestriction.days, 'day').toDate();

        let firstPossibleDate = loopStart;

        if (this.SITE_CONFIG.site === 'branas') {
          firstPossibleDate = moment().add(1, 'day');
        } else if (this.SITE_CONFIG.site === 'kungsberget') {
          firstPossibleDate = moment().add(2, 'day');
        }

        const tz = moment.tz.guess(true);
        const now = moment.tz(moment(), tz);

        if (now.hours() >= 12) {
          firstPossibleDate = firstPossibleDate.add(1, 'day');
        }

        if (firstPossibleDate > loopStart) {
          loopStart = firstPossibleDate.toDate();
        }
      }

      let current = loopStart;

      while (current < end) {
        next = moment(current).add(1, 'days');
        if (this.SITE_CONFIG.season.winter.closed.indexOf(next.format('YYYY-MM-DD')) === -1) {
          this.validStartDates.push(next.format('YYYY-MM-DD'));
        }
        current = next.toDate();
      }

      let person = this.$store.state.cart.rentals[this.$route.params.person];

      if (!person) {
        person = {};
      }

      if (person.startDate) {
        this.pickedStartDate = person.startDate;
        this.selectedDays = person.days;
        if (window.screenSize() > window.screenMobile) {
          if (this.name) {
            this.stage = 16;
          }
        } else if (this.name) {
          this.stage = 13;
        }

        this.startMonth = moment(this.pickedStartDate).toDate();
      } else {
        const accomodations = JSON.parse(JSON.stringify(this.$store.state.cart.accomodations));
        const confirmed = accomodations.filter(accomodation => accomodation.confirmed);

        const personBefore = this.$store.state.cart.rentals[this.$route.params.person - 1];
        if (personBefore) {
          this.pickedStartDate = personBefore.startDate;
          this.selectedDays = personBefore.days;
          this.startMonth = moment(this.pickedStartDate).toDate();
          this.priceType = personBefore.priceType;
        } else if (confirmed.length) {
          // Set date
          const original = moment(confirmed[0].period.date_arrival);
          let start = null;
          let startOk = false;
          const enddate = moment(confirmed[0].period.date_departure);

          let iterator = 0;
          const itLength = this.validStartDates.length;
          while (iterator < itLength) {
            start = original.clone().add(iterator, 'days');
            if (this.validStartDates.indexOf(start.format('YYYY-MM-DD')) !== -1) {
              startOk = true;
              break;
            }
            iterator += 1;
          }

          if (startOk) {
            this.pickedStartDate = start.toDate();
            this.pickedEndDate = enddate.toDate();
            this.selectedDays = moment(this.pickedEndDate).diff(this.pickedStartDate, 'days') + 1;

            this.startMonth = moment(this.pickedStartDate).toDate();
          } else {
            this.pickedStartDate = null; // moment(loopStart).add(1, 'days').toDate();
            this.selectedDays = null;
            // this.startMonth = moment(this.validStartDates[0]).toDate(); // todo
            this.startMonth = moment().toDate(); // TODO: QUICK FIX
          }
        } else {
          this.pickedStartDate = null; // moment(loopStart).add(1, 'days').toDate();
          this.selectedDays = null;
          // this.startMonth = moment(this.validStartDates[0]).toDate(); // todo
          this.startMonth = moment().toDate(); // TODO: QUICK FIX
        }
      }

      await this.validateDate();
    },
    validateStep10() {
      if (this.name) {
        if (this.selectedDays && window.screenSize() > window.screenMobile) {
          this.stage = 16;
        } else {
          this.stage = 13;
        }
        if (!this.loading) {
          this.selectedAge = null;
          this.selectedCategory = null;
          this.selectedSubCategory = null;
          this.selectedType = null;
          this.update();
        }
      }
    },
    validateStep13() {
      if (this.name) {
        this.stage = 16;
        if (!this.loading) {
          this.selectedAge = null;
          this.selectedCategory = null;
          this.selectedSubCategory = null;
          this.selectedType = null;
          this.update();
        }
      }
    },
    validateStep16() {
      if (this.selectedAge) {
        this.stage = 20;
        if (!this.loading) {
          this.selectedCategory = null;
          this.selectedSubCategory = null;
          this.selectedType = null;
          this.update();
        }
      }
    },
    pickedCategory(v) {
      this.selectedSubCategory = v;
      if (!this.loading) {
        // Hardcoded
        if (this.selectedSubCategory === 'snowblades') {
          this.$nextTick(() => {
            const $this = this;
            this.openModal(['GeneralModal', {
              title: this.$i18n.t('skirental.special-rules.snowblades.title'),
              content: this.$i18n.t('skirental.special-rules.snowblades.content'),
              buttons: [{
                title: this.$i18n.t('general.i-understand'),
                class: 'small',
                click: () => {
                  $this.closeModal();
                },
              }],
            }]);
          });
        } else if (this.selectedSubCategory === 'cross_country' && (this.selectedAge === 'children' || this.selectedAge === 'youths') && this.SITE_CONFIG.site === 'branas') {
          this.$nextTick(() => {
            const $this = this;
            this.openModal(['GeneralModal', {
              title: this.$i18n.t('skirental.special-rules.crosscountry-children-branas.title'),
              content: this.$i18n.t('skirental.special-rules.crosscountry-children-branas.content'),
              buttons: [{
                title: this.$i18n.t('general.i-understand'),
                class: 'small',
                click: () => {
                  $this.closeModal();
                },
              }],
            }]);
          });
        }

        this.refreshProductsFromCategory(this.selectedAge, this.selectedSubCategory);

        this.selectedType = null;
        this.update();
      }
    },
    setCategory1(category) {
      if (this.selectedCategory) {
        this.selectedCategory = '';
      } else {
        this.selectedCategory = category;
      }

      if (this.selectedCategory) {
        this.stage = 30;
      } else if (!this.loading) {
        this.stage = 20;
      }

      this.selectedSubCategory = null;
      this.selectedType = null;

      if (!this.loading) {
        this.update();

        // Hardcoded
        if (this.selectedCategory === 'snowboard' && this.selectedAge === 'children') {
          const $this = this;
          this.openModal(['GeneralModal', {
            title: this.$i18n.t('skirental.special-rules.snowboard-children.title'),
            content: this.$i18n.t('skirental.special-rules.snowboard-children.content'),
            buttons: [{
              title: this.$i18n.t('general.i-understand'),
              class: 'small',
              click: () => {
                $this.closeModal();
              },
            }],
          }]);
        } else if (this.selectedCategory === 'alpine' && this.selectedAge === 'children' && ['storstenshojden', 'tolvmannabacken'].indexOf(this.SITE_CONFIG.site) !== -1) {
          this.$nextTick(() => {
            const $this = this;
            this.openModal(['GeneralModal', {
              title: 'Hjälm ingår',
              content: 'Hjälm ingår i våra skidpaket för barn 0-6 år.',
              buttons: [{
                title: this.$i18n.t('general.i-understand'),
                class: 'small',
                click: () => {
                  $this.closeModal();
                },
              }],
            }]);
          });
        }
      }

      if (this.selectedSubCategory) {
        this.refreshProductsFromCategory(this.selectedAge, this.selectedSubCategory);
      } else {
        this.refreshProductsFromAge(this.selectedAge);
      }

      const $this = this;
      if (this.selectedCategory === 'other' && !this.loading) {
        this.openModal(['SkiRentalCategories', {
          click: $this.pickedCategory,
          options: $this.subCategories,
        }]);
      }

      if (this.selectedCategory === 'skipass' && !this.loading) {
        this.next();
      }
    },
    async refreshProductsFromAge(age) {
      let date = '';
      if (this.pickedStartDate) {
        date = moment(this.pickedStartDate).format('YYYY-MM-DD');
      }
      const days = this.selectedDays;
      this.setCategoriesFromSearch({ age, date, days });
    },
    async refreshProductsFromCategory(age, category) {
      let date = '';
      if (this.pickedStartDate) {
        date = moment(this.pickedStartDate).format('YYYY-MM-DD');
      }
      const days = this.selectedDays;
      this.setCategoriesFromSearch({ age, date, days, category });
    },
    setAge(value, skipWarning) {
      if (!this.loading) {
        if (this.stage < 16 && (typeof skipWarning === 'undefined' || !skipWarning)) {
          this.openWarningModal();
          return;
        }
      }

      if (this.selectedAge) {
        this.selectedAge = '';
      } else {
        this.selectedAge = value;
      }

      if (this.selectedAge) {
        this.stage = 20;
      } else if (!this.loading) {
        this.stage = 16;
      }

      if (!this.selectedDays) {
        this.stage = 13;
      }

      this.selectedCategory = null;
      this.selectedSubCategory = null;
      this.selectedType = null;

      this.refreshProductsFromAge(this.selectedAge);
      if (!this.loading) {
        this.update();
      }
    },
    update(forceOverwrite) {
      if (!this.loading) {
        this.updateRentalPerson({
          index: this.$route.params.person,
          name: (this.name || '').toString().toUpperCase(),
          age: this.selectedAge,
          category: this.selectedCategory,
          subCategory: this.selectedSubCategory,
          type: this.selectedType,
          searchPackage: (this.pickLevel() ? this.searchPackage : ''),
          startDate: this.pickedStartDate,
          days: this.selectedDays,
          priceType: this.priceType,
          forceOverwrite,
        });
      }
    },
    next() {
      if (!this.selectedDays) {
        this.openModal(['GeneralModal', {
          title: this.$i18n.t('skirental.rules.pick-date-title'),
          content: this.$i18n.t('skirental.rules.pick-date'),
        }]);
        return;
      }

      this.update(true);

      const index = parseInt(this.$route.params.person, 10) || 0;
      if (this.selectedCategory === 'skipass' && !this.loading) {
        this.$store.state.cart.rentals[index].onlySkipass = true;
      } else {
        this.$store.state.cart.rentals[index].onlySkipass = false;
      }

      this.$router.push({
        path: `/skidhyra/${this.$route.params.person}/produkter`,
        query: {
          age: this.selectedAge,
          category: this.selectedSubCategory || this.selectedCategory,
          type: this.selectedType,
          level: (this.pickLevel() ? this.searchPackage : ''),
        },
      });
    },
    pickLevel() {
      if (!this.SITE_CONFIG.rental.use_levels) {
        return false;
      }
      return (
        this.selectedType === 'package'
        && this.selectedCategory === 'alpine'
        && (
          this.selectedAge === 'youths'
          || this.selectedAge === 'adults'
          || this.selectedAge === 'children'
          || this.selectedAge === 'seniors'
        )
      );
    },
    setType(type) {
      if (this.selectedType) {
        this.selectedType = '';
      } else {
        this.selectedType = type;
      }

      if (this.selectedType === 'package') {
        this.stage = 40;
      } else if (!this.loading) {
        this.stage = 30;
      }

      // Special combo to set stage 40
      const specialCombo = this.pickLevel();

      if (this.loading) {
        if (!specialCombo) {
          this.selectedType = null;
          if (this.stage === 40) {
            this.stage = 30;
          }
        } else {
          this.searchPackage = null;
        }
      }

      if (!this.loading && specialCombo) {
        this.update();
      } else if (!this.loading && this.selectedType) {
        this.next();
      }
    },
    setPackage(p) {
      this.searchPackage = p;
      if (this.searchPackage) {
        this.stage = 50;
      }

      if (this.loading) {
        if (this.stage === 50) {
          this.searchPackage = null;
          this.stage = 40;
        }
      }

      if (!this.loading) {
        this.next();
      }
    },
    remove() {
      const $this = this;
      const index = $this.$route.params.person;
      this.openModal(['GeneralModal', {
        title: this.$i18n.t('general.are-you-sure'),
        content: this.$i18n.t('skirental.remove-confirmation', { skier: this.name }),
        buttons: [
          {
            title: this.$i18n.t('general.yes'),
            class: 'small',
            click: () => {
              $this.$store.state.cart.rentals.splice(index, 1);
              $this.closeModal();
              $this.$router.push({ name: 'ski rental overview' });
            },
          },
          {
            title: this.$i18n.t('general.no'),
            class: 'small white border',
            click: () => {
              $this.closeModal();
            },
          },
        ],
      }]);
    },
    async validateDate() {
      if (this.pickedStartDate && this.selectedDays) {
        const start = moment(this.pickedStartDate).format('YYYY-MM-DD');
        const { success } = await API.get(`config/is-rental-dates-allowed?date=${start}&days=${this.selectedDays}`);
        if (!success) {
          this.pickedStartDate = null;
          this.selectedDays = null;
          this.startMonth = moment().toDate();
          this.pickedEndDate = null;
        }
      }
    },
    async fetchSkiers() {
      this.loadingSkiers = true;
      const { skiers } = await API.get('/account/user');
      this.skiers = skiers || [];
      this.loadingSkiers = false;
    },
    onLogin() {
      this.fetchSkiers();
    },
    setSkier(value) {
      const skier = this.skiers.find(s => s.guid === value.value);
      this.skier = skier || {};

      if (!skier) {
        this.name = '';
        this.selectedAge = null;
        this.validateName(new Event('input'));
        this.validateStep10({});
        this.setAge(null);
        this.updateMeasurements(null, null, null, null, null);
        return;
      }

      this.name = `${skier.first_name || ''} ${skier.last_name || ''}`;

      const age = skier.age_category;

      this.validateName(new Event('input'));
      this.validateStep10({});
      this.setAge(age, true);
      this.updateMeasurements(skier.measurement_height,
        skier.measurement_weight, skier.measurement_shoe_size,
        skier.measurement_clothsize, skier);
    },
    updateMeasurements(height, weight, shoeSize, clothsize, skier) {
      this.updateRentalPersonMeasurements({
        index: this.$route.params.person,
        lengthCm: parseInt(height, 10) || null,
        weight: parseInt(weight, 10) || null,
        shoeSize: parseInt(shoeSize, 10) || null,
        clothsize: clothsize || null,
        skier,
      });
    },
  },
};
</script>

<style scoped lang="stylus">
@import '~@/global.styl'

.content
  margin-bottom 15px
  margin-top 15px
  &.disabled
    opacity 0.3
  label
    text-align left
    margin-left 10px
hr
  height 2px
  opacity 0.19
  background-color white
  max-width 447px

h1
  united-heavy()
  uppercase()
  color white
  +max-mobile()
    font-size: 20px!important


h2
  uppercase()
  font-family inherit
  color white
  font-size 11px
  font-weight bold
  margin-bottom 5px
  span
    text-transform none
    font-size 10px
    font-weight 300

affix()
  width 4em
  display flex
  align-items center
  justify-content center

.level-phone
  display: none
  +max-mobile()
    display: block;

.label
  color white
  uppercase()
  font-size 11px
  font-weight bold
  color #ffffff
  margin-bottom 8px
  margin-left 10px
  text-align: left
  &.label-products
    display: none
    +max-mobile()
      display: inline-block;
      width: 60%;

  +max-mobile()
    text-align left
    max-width: 60%;
    margin: 0 auto 8px;
  &.no-left-margin
    margin-left 0

.flex
  display flex
  justify-content center
  +max-mobile()
    flex-wrap wrap
  .control
    margin-left 15px
    margin-right 15px
    .flexer
      display flex
      align-items center
      cursor default
      align-items stretch
      transition-ease()
      border-radius: 3px;
      border: solid 2px #bfd9e1;
      background-color: #fff;
      .input
        input()
        border 0
        border-radius 0
        background none
        line-height: 1.7em;
      .suffix
        affix()
        transition-ease()
        background-color: #fff;
        border-left border
      &.selected
        background-color: #5aa478;
        border-color: #c7dcb7;
        .input
          color white
          font-weight bold
          text-transform: uppercase
          font-size: 11px
          padding: 11px 15px;
        .suffix
          background-color: #e7f1df;
          cursor pointer
          border-left: solid 2px #c7dcb7
          width: 42px
  .box
    border-radius 4px
    background-color #ffffff
    box-shadow 0 0 20px 0 rgba(0, 0, 0, 0.15)
    padding 20px 25px 20px
    margin 10px
    width 240px
    max-width 33%
    margin-top 25px
    margin-bottom 25px
    position relative
    +max-mobile()
      width 70%
      max-width 100%
      margin-bottom 10px
      margin-top 0
      padding: 17px 18px 15px;
    ul
      padding-left: 10px
    .banner
      position absolute
      top: 20px;
      right: -105px;
      transform rotate(39deg)
      font-family Interstate
      font-size 10px
      font-weight bold
      letter-spacing 0.3px
      text-align center
      color #004d73
      background-color rgba(191, 217, 225, 0.7)
      padding 6px
      uppercase()
      width 300px
      text-align: center
    h3
      text-align center
      united-heavy()
      uppercase()
      font-size 16px
      +max-mobile()
        margin-bottom: 6px
    button
      width: 150px;
      padding: 10px 15px 4px;
      margin: 25px auto 0px;
      +max-mobile()
        display: none
    li
      list-style disc
      font-size 14px
      font-weight 300
      list-style-image url(https://static.booking.branasgruppen.se/static/svg/punklista-check.svg)
      max-width: 185px;
      margin: 0 auto 8px;
      +max-mobile()
        font-size: 12px
        max-width: 165px;
    &.larger
      margin-top 10px
      margin-bottom 10px
      width 290px
      overflow hidden
      padding-top: 35px
      +max-mobile()
        width 70%
        max-width 100%
        margin-top: 0px;
        padding-top: 20px
      h3
        font-size 18px
        margin-bottom: 13px
        +max-mobile()
          font-size: 16px
          margin-bottom: 6px

.dropdown-wrapper
  input()
  background none
  padding 0
  border 0
  width auto
  display inline-block
  min-width: 270px

.button
  margin 10px
  transition all 0.05s
  position relative
  padding 10px 16px
  margin-top 0
  margin-bottom 10px
  .underlined
    position: relative
  +max-mobile()
    width: 60%
    height: 50px
    padding-top: 15px
    margin-bottom: 15px

  &.has-description
    padding-top: 8px;
    padding-bottom: 7px;
    min-width: 115px;
    //border-bottom: solid 4px #bfd9e1
    //min-width: 210px;
    font-size: 12px;
    +max-mobile()
      min-width: 60%;
      margin-bottom: 15px;
      max-width: 60%;
    span
      display block
      font-size 11px
      font-weight 300
      line-height 1.09
      text-align center
      color #161616
      text-transform none
      margin-top 3px
    &.checked
      min-width 0
      padding-top 10px
      padding-bottom 10px
      min-width 95px
      font-size: 11px
      span
        color white
        display: none
  &.checked:hover
    background-color #d68605
    border-color rgba(255, 255, 255, 0.7)
    transition-bt()
  &.checked:after
    content ""
    position absolute
    top: -8px
    right: -8px
    height: 17px
    width: 17px
    background-image url(https://static.booking.branasgruppen.se/static/svg/circle-green-minus.svg)
    background-size cover
  &.checked:hover:after
    background-image url(https://static.booking.branasgruppen.se/static/svg/circle-orange-minus.svg)
    transition-bt()

button
 &.ski-bt
   font-size: 12px
   border-bottom: 5px solid rgb(38, 110, 147)
   background-color: rgb(38, 110, 147)
   border: 0px
   padding-bottom: 10px!important

.inline-block.min-width
  min-width: 266px;

.background-blue
  position: relative
  +max-mobile()
    padding-top: 50px
.remove-user
  position absolute
  right 50px
  top 20px
  color white
  font-size 9px
  letter-spacing 0.5px
  text-align right
  color #ffffff
  uppercase()
  button
    margin-left 5px
  +max-tablet()
    position fixed
    left auto
    width auto
    text-align: center;
    margin-top 0px
    right: 10px;
    bottom: 2%;
    top: auto;
    z-index: 9999


.back
  position absolute
  left 30px
  top 20px
  width: auto
  display inline-block
  padding: 5px 10px;

.language-switcher
  position absolute
  right 10px
  top 20px
  width: auto
  display inline-block
  padding: 5px 10px;

+max-mobile()
  hr
    display none
  .back
    position absolute
    top 0
    left 0
    width: 100%
    display inline-block
    font-size: 14px
    padding: 14px 18px;
    &.text
      font-size: 14px
  .language-switcher
    top 3px
  .a-step
    display none
  .step-10,
  .step-13
    .step-10
      display block
    .step-13
      display block
  .step-16
    .step-16
      display block
  .step-20
    .step-20
      display block
  .step-30
    .step-30
      display block
  .step-40
    .step-40
      display block

.next
  display none
  /*position fixed
  left 0
  bottom 0
  width 100%
  z-index 2*/
  text-align: center
  padding-left padding-mobile
  padding-right padding-mobile
  padding-top space-2
  +max-mobile()
    display: block
.white-text
  border-radius 2px
  background-color #F0F6EC
  border solid 1px #d1e0c2
  padding 15px 27px
  max-width 400px
  b
    font-size 11px
    font-weight bold
    color #1c1c1c
    display block
    margin-bottom 5px
    uppercase()
    .icon
      margin-right 3px
      position relative
      top -1px
  p
    font-size 14px
    font-weight 300
    line-height 1.3
    color #262626
    margin 0
  &.small
    padding 10px 8px
    p
      font-size 11px
      color #1c1c1c

.rental-closed
  text-align center
  margin 4em auto
  max-width 650px
  color white
  font-size 16px
  line-height 1.5
  padding 0 20px
</style>



// WEBPACK FOOTER //
// SkiRentalUser.vue?6bb53930